// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Cell, Dialog } from "react-vant";
import "./index.css";
import { Button } from "antd";
import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { newsApi } from "../../../../api/news-api";

export default function CenterPage() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [helpList, setHelpList] = useState([] as any[]);
  const [index, setIndex] = useState(1);
  const lan = localStorage.getItem("i18n");
  const name = lan == "zh" ? "" : lan.charAt(0).toUpperCase() + lan.slice(1);

  const getNodes = () => {
    const nodes = [];
    for (let i = 0; i < helpList.length; i++) {
      const help = helpList[i];
      nodes.push(
        <div
          key={help.id}
          className="bg-neutral-800 hover:bg-neutral-700 rounded-lg p-4 mb-3 cursor-pointer transition-all duration-300 ease-in-out border border-neutral-700 hover:border-primary-light shadow-card"
          onClick={() => {
            navigate(`/helpInfo/${help.id}`);
          }}
        >
          <div className="flex items-center justify-between">
            <div className="text-neutral-200 text-base font-medium">
              {help[`type${name}`]}
            </div>
            <div className="flex items-center text-neutral-400">
              <svg 
                className="w-5 h-5 transition-transform duration-300 transform group-hover:translate-x-1" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </div>
      );
    }
    return nodes;
  };

  const loadData = async () => {
    const data = await newsApi.list();
    if (data.ok) {
      setHelpList(data.data);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="min-h-screen bg-neutral-900 text-white">
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="space-y-4 animate-fade-in">
          {getNodes()}
        </div>
      </div>
    </div>
  );
}
